export const report_inform_lang={
  TH:{
    month_search:"ค้นหาข้อมูลใบทวงหนี้",
    choose_year:"เลือกปี",
    choose_month:"เลือกเดือน",
    choose_type_report:"เลือกช่วงเวลา",
    choose_day: "เลือกวัน",
    all_bill:"ใบเสร็จรับเงินทั้งหมด",
    total_bill:"ยอดรวมทั้งหมด",
    header_table:"ข้อมูลสถานที่ผู้เสียค่าธรรมเนียม",
    search:"ค้นหา",
    place_id: "รหัสที่อยู่",
    place_desc: "ที่อยู่/บ้านเลขที่",
    place_type_desc: "ชนิดที่อยู่",
    customer_name: "ชื่อผู้เสียภาษี",
    place_address: "ที่อยู่",
    fee_type_description: "ประเภทค่าธรรมเนียม",
    fee_type_unit: "รายละเอียดค่าธรรมเนียม",
    show_detail: "แสดงรายละเอียด",
    back: "ย้อนกลับ",
    bill_id: "รหัสใบแจ้งหนี้",
    bill_desc: "รายละเอียด",
    bill_date: "วันที่ออกเอกสาร",
    bill_user: "ผู้ออกเอกสาร",
    bill_discount: "ส่วนลด",
    bill_total_price: "ยอดที่ต้องชำระ",
    bill_payment_desc: "ประเภทการชำระ",
    print_invoice:"พิมพ์ใบทวงหนี้",
    due_date: "กำหนดชำระ",
    status_code: "สถานะการชำระ",
    report_count: "จำนวนใบทวงหนี้ : ",
    place_count: "จำนวนบ้าน",
    report_price: "ยอดรวมค่าธรรมเนียม : ",
    show_inform: "แสดงใบทวงหนี้",
    customer_id:"รหัสลูกค้า",
    request_general_id:"หมายเลขคำร้อง",
    request_alert:"กรุณากรอกหมายเลขคำร้อง",
    cancel_invoice:"ยกเลิกใบทวงหนี้",
    cancel_title: "ต้องการยกเลิกใบทวงหนี้นี้ใช่หรือไม่?",
    cancel_detail: "กรุณายืนยันข้อมูล",
    gen_type_name:"ประเภทการชำระเงิน",
    back_to_detail:"กลับไปยังหน้ารายละเอียด",
    want_delete:"ฉันต้องการลบ",
    confirm_delete:"คุณต้องการลบข้อมูลใบทวงหนี้นี้ใช่หรือไม่?",
    warning_delete:"ข้อมูลลบแล้วไม่สามารถยอนกลับได้!!",
    close:"ปิดหน้านี้",
    deleted: "ยกเลิกใบทวงหนี้ เรียบร้อยแล้ว",
    print_inform_3x4:"พิมพ์ใบทวงหนี้ขนาดพกพา",


    type_pay:"เลือกสถานะการชำระเงิน",

    date_start: 'เลือกวันเริ่มต้น/สิ้นสุด',
    show_invoice: "แสดงใบแจ้งหนี้",
    invoice_id: "รหัสใบแจ้งหนี้",
    fee_id: "รหัสค่าธรรมเนียม",
    fee_description: "รายละเอียดค่าธรรมเนียม",
    user_id: "ผู้ออกใบ",
    create_datetime: "วันที่ออกใบแจ้งหนี้",
    total_price: "ราคารวม",
    fee_price: "ค่าธรรมเนียม",
   
    warining_delete: "ข้อมูลลบลบแล้วไม่สามารถยอนกลับได้!!",
   
    print_invoice_3x4: "พิมพ์ใบเสร็จรับเงินขนาดพกพา",
  },
  EN:{
    month_search:"Search by year/month/day",
    choose_year:"Choose year",
    choose_month:"Choose month",
    choose_type_report:"Choose time report",
    choose_day: "Choose day",
    all_bill:"All Invoices",
    total_bill:"Total Invoices",
    back_to_detail:"Back to detail",
    search:"Search",
    place_id: "Place ID",
    place_desc: "Place Desc",
    place_type_desc: "Place Type",
    gen_type_name:"Type fee",
    customer_name: "Customer Name",
    customer_id:"Customer_id",
    place_address: "Address",
    fee_type_description: "Fee Description",
    fee_type_unit: "Fee",
    show_detail: "Detail",
    back: "Back",
    bill_id: "Invoice Id",
    date_start:'Select start/end date',
    place_count:"Place count",
    bill_desc: "Invoice Detail",
    bill_date: "Invoice Date",
    bill_user: "User Make",
    print_invoice: "Print Inform",
    due_date: "Due Date",
    status_code: "Status",
    report_count: "Total Inform : ",
    report_price: "Total Price Inform : ",
    show_inform: "Show Inform",

    request_general_id:"Request general id",
    request_alert:"Please input request general id",
    cancel_invoice:"Cancel",
    cancel_title: "Are you sure to cancel this inform??",
    cancel_detail: "Please confirm.",

    want_delete:"Yes delete it",
    confirm_delete:"Are you sure to delete this inform item?",
    warining_delete:"Deleted data can't recovery!",
    close:"Close",
    deleted: "Cancel inform success",
    print_inform_3x4:"Pocket size receipt printing",

    print_invoice_3x4: "Pocket size receipt printing",
   
    show_invoice: "Show Invoice",
    invoice_id: "Invoice Id",
    fee_id: "Fee Id",
    fee_description: "Fee decription",
    user_id: "User Id",
    create_datetime: "Create Datetime",
    total_price: "Total Price",
    fee_price: "Fee Price",
    type_pay:"Select type",
    bill_total_price: "Amount to be paid",


  }
}
